import { ButtonConfig } from '@zipari/shared-ds-util-button';
import { SsoPaymentConfig } from '../../chords/sso-payment/sso-payment.model';

export interface PaymentCardConfiguration {
  title: PaymentCardItem;
  details: {
    prop: string;
    left: PaymentCardItem;
    right: PaymentCardItem;
  };
  autopay: PaymentCardItem;
  amount: PaymentCardItem;
  condition_date: PaymentCardItem;
  condition_label: PaymentCardItem;
  footer: {
    view_details_button: ButtonConfig;
    make_payment_button: ButtonConfig;
    make_pre_payment_button?: ButtonConfig;
  };
  sso?: SsoPaymentConfig;
  hideAccountStatus?: boolean;
  billPeriod?: PaymentCardItem;
  billNumber?: PaymentCardItem;
  statusVisibility: {
    open: boolean;
    cancelled: boolean;
    paid: boolean;
    overdue: boolean;
  };
}

interface PaymentCardItem {
  prop: string;
  label?: string;
}
